__turbopack_context__.v({
  "about-exp-links": "expFooter-module-scss-module__Eq8rUq__about-exp-links",
  "block": "expFooter-module-scss-module__Eq8rUq__block",
  "block1": "expFooter-module-scss-module__Eq8rUq__block1",
  "block2": "expFooter-module-scss-module__Eq8rUq__block2",
  "block3": "expFooter-module-scss-module__Eq8rUq__block3",
  "block4": "expFooter-module-scss-module__Eq8rUq__block4",
  "component": "expFooter-module-scss-module__Eq8rUq__component",
  "contact": "expFooter-module-scss-module__Eq8rUq__contact",
  "contact-item": "expFooter-module-scss-module__Eq8rUq__contact-item",
  "feature-flags": "expFooter-module-scss-module__Eq8rUq__feature-flags",
  "features": "expFooter-module-scss-module__Eq8rUq__features",
  "footer-big-text": "expFooter-module-scss-module__Eq8rUq__footer-big-text",
  "footer-bottom": "expFooter-module-scss-module__Eq8rUq__footer-bottom",
  "footer-links": "expFooter-module-scss-module__Eq8rUq__footer-links",
  "footer-top": "expFooter-module-scss-module__Eq8rUq__footer-top",
  "footer-top-left": "expFooter-module-scss-module__Eq8rUq__footer-top-left",
  "footer-top-right": "expFooter-module-scss-module__Eq8rUq__footer-top-right",
  "join-button": "expFooter-module-scss-module__Eq8rUq__join-button",
  "join-image-container": "expFooter-module-scss-module__Eq8rUq__join-image-container",
  "join-link": "expFooter-module-scss-module__Eq8rUq__join-link",
  "join-section": "expFooter-module-scss-module__Eq8rUq__join-section",
  "join-section-mobile-container": "expFooter-module-scss-module__Eq8rUq__join-section-mobile-container",
  "office-address": "expFooter-module-scss-module__Eq8rUq__office-address",
  "social-ig-icon": "expFooter-module-scss-module__Eq8rUq__social-ig-icon",
  "social-x-icon": "expFooter-module-scss-module__Eq8rUq__social-x-icon",
  "socials": "expFooter-module-scss-module__Eq8rUq__socials",
});
